module.exports = __webpack_public_path__ + "static/img/icon-win.727ea307.png";